import { render } from "./ProjectsProgressChart.vue?vue&type=template&id=0a6616cc&ts=true"
import script from "./ProjectsProgressChart.vue?vue&type=script&lang=ts"
export * from "./ProjectsProgressChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__